/** Formato MICR / código de barras: sucursal de 3 dígitos. */
export const CHEQUE_NRO_SUCURSAL_MAX_DIGITOS = 3;

/** Formato MICR / código de barras: número de cheque de hasta 8 dígitos. */
export const CHEQUE_NRO_CHEQUE_MAX_DIGITOS = 8;

export function esNroSucursalChequeValido(value: string | number | null | undefined): boolean {
  const s = String(value ?? '').trim();
  if (!s || !/^\d+$/.test(s)) return false;
  if (s.length > CHEQUE_NRO_SUCURSAL_MAX_DIGITOS) return false;
  const n = Number(s);
  return Number.isFinite(n) && n > 0 && n <= 999;
}

export function esNroChequeTerceroValido(value: string | number | null | undefined): boolean {
  const s = String(value ?? '').trim();
  if (!s || !/^\d+$/.test(s)) return false;
  if (s.length > CHEQUE_NRO_CHEQUE_MAX_DIGITOS) return false;
  const n = Number(s);
  return Number.isFinite(n) && n > 0 && n <= 99_999_999;
}

export function mensajeErrorNroSucursalCheque(value: string | number | null | undefined): string | null {
  const s = String(value ?? '').trim();
  if (!s) return 'Ingresá el número de sucursal';
  if (!/^\d+$/.test(s)) return 'Solo se permiten dígitos';
  if (s.length > CHEQUE_NRO_SUCURSAL_MAX_DIGITOS) {
    return `Máximo ${CHEQUE_NRO_SUCURSAL_MAX_DIGITOS} dígitos`;
  }
  const n = Number(s);
  if (!Number.isFinite(n) || n <= 0) return 'Debe ser mayor a cero';
  if (n > 999) return 'Sucursal fuera de rango (1–999)';
  return null;
}

export function mensajeErrorNroChequeTercero(value: string | number | null | undefined): string | null {
  const s = String(value ?? '').trim();
  if (!s) return 'Ingresá el número de cheque';
  if (!/^\d+$/.test(s)) return 'Solo se permiten dígitos';
  if (s.length > CHEQUE_NRO_CHEQUE_MAX_DIGITOS) {
    return `Máximo ${CHEQUE_NRO_CHEQUE_MAX_DIGITOS} dígitos`;
  }
  const n = Number(s);
  if (!Number.isFinite(n) || n <= 0) return 'Debe ser mayor a cero';
  if (n > 99_999_999) return 'Número de cheque fuera de rango';
  return null;
}
